import { render } from "./ManageTemplate.vue?vue&type=template&id=1fdfb082&scoped=true&lang=pug"
import script from "./ManageTemplate.vue?vue&type=script&lang=js"
export * from "./ManageTemplate.vue?vue&type=script&lang=js"

import "./ManageTemplate.vue?vue&type=style&index=0&id=1fdfb082&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdfb082"]])

export default __exports__